import { render, staticRenderFns } from "./ModalNotAllowed.vue?vue&type=template&id=5a704420&"
import script from "./ModalNotAllowed.vue?vue&type=script&lang=js&"
export * from "./ModalNotAllowed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports